export class SetupTaskParameter {
  component: string;
  parameter: string;
}
